import { render } from "./NavbarPublic.vue?vue&type=template&id=ac5261e0&scoped=true"
import script from "./NavbarPublic.vue?vue&type=script&lang=js"
export * from "./NavbarPublic.vue?vue&type=script&lang=js"

import "./NavbarPublic.vue?vue&type=style&index=0&id=ac5261e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5261e0"]])

export default __exports__